const CalendarEventAcceptanceTypes = Object.freeze({
  NeedsAction: "Needs Action",
  Accepted: "Accepted",
  Declined: "Declined",
});

export default CalendarEventAcceptanceTypes;
